import styled from '@mui/material/styles/styled';
import ListItem from '@mui/material/ListItem';
import Typography from '@mui/material/Typography';

export const StyledListItem = styled(ListItem)({
  display: 'flex', 
  alignItems: 'center',
  justifyContent: 'space-between', 
  gap: '8px', 
  marginBottom: 16
});
export const ItemTitle = styled((props) => (
  <Typography variant='subtitle1' noWrap  {...props} />
))({
  width: '100%',
  fontWeight: 600,
});

